import React from 'react';
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { ProfitLossExpenseRevenueType } from '../../../../redux/reports/reportsType';
import { TableLoader, TableHeader } from '../../../commons';
import ProfitLossTableData from './ProfitLossTableData';

type AppProps = {
  fetching: boolean;
  tableData: [] | ProfitLossExpenseRevenueType[];
  tableHeaders: TableHeadersType[];
  netAmount: number | null | undefined;
  netAmountName: string;
  client_code?: number;
  start_date: string;
  end_date: string;
  company_name: string;
  isLedgerStatementPresent?: boolean;
  currencySign: string | undefined;
  selectedBranchId?:number|null;
  branchName?:string;
}

const ProfitLossTable = ({
  fetching,
  tableData,
  tableHeaders,
  netAmount,
  netAmountName,
  client_code,
  company_name,
  start_date,
  end_date,
  isLedgerStatementPresent,
  currencySign,
  selectedBranchId,branchName,
}: AppProps) => {

  return (
    <>
      {
        fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={8}
        /> :
          <div className="jobsType">
            <table className="table table-bordered thead-light">
              <thead className='text-start'>
                <TableHeader
                  tableHeader={tableHeaders}
                />
              </thead>
              <tbody>
                <ProfitLossTableData
                  tableData={tableData}
                  tableHeaders={tableHeaders}
                  netAmount={netAmount}
                  netAmountName={netAmountName}
                  client_code={client_code}
                  company_name={company_name}
                  start_date={start_date}
                  end_date={end_date}
                  isLedgerStatementPresent={isLedgerStatementPresent}
                  currencySign={currencySign}
                  selectedBranchId={selectedBranchId}
                  branchName={branchName}
                />
              </tbody>
            </table>
          </div>
      }
    </>
  )
};

export default ProfitLossTable;